export enum RequestsType {
  SignUp = 'sign_up',
  Tenant = 'os_access',
  Hierarchy = 'hierarchy_access',
  Hub = 'hub_access',
}
